import React, { useState } from 'react';
import { useQueryClient } from 'react-query';

import { updateFilter } from 'apis/FilterAPI';
import ConfirmModal from 'common/Modal/ConfirmModal';
import { useRootContext } from 'components/layout/RootContext';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import { ViewFilters } from 'components/View/types';
import { transformFilterOutbound } from 'components/View/utils';

type Props = {
  open: boolean;
  onCancel: () => void;
};

const SalesBattlecardSaveFilterModal = ({ open, onCancel }: Props) => {
  const { showMessage } = useRootContext();
  const { view, viewFilters, viewId } = useCommunityViewContext();
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);

  const handleSave = () => {
    const filterId = view?.filter?.id;
    if (!filterId || !viewFilters) return;

    setLoading(true);
    const payload = transformFilterOutbound(viewFilters as ViewFilters);
    updateFilter(filterId, payload)
      .then(() => {
        queryClient.invalidateQueries({ queryKey: ['view', viewId] });
        onCancel();
        showMessage('success', 'Sales Battlecard filter saved.');
      })
      .catch(() => showMessage('error', 'Failed to save Sales Battlecard filter.'))
      .finally(() => setLoading(false));
  };

  return (
    <ConfirmModal
      open={open}
      title={'Save Filter'}
      description={'Would you like to save this filter so that it persists next time you visit this page?'}
      confirmLabel={'Save'}
      onConfirm={handleSave}
      onCancel={onCancel}
      disabled={loading}
    />
  );
};

export default SalesBattlecardSaveFilterModal;
